import {useSelector} from 'react-redux'
import {Col, Form, Row} from 'react-bootstrap'
import {FormCheck} from '../Utilities/Form'
import {isBusiness, useInputDataState, useLabels} from '../../functions'

export const FlexOffer = () => {
    const labels = useLabels()
    const flexOffer = useSelector(state => state.customer.data.flexOffer)
    const script = useSelector(state => state.customer.data.script)
    const plan = useSelector(state => state.customer.data.plan)
    const [flexDecision, setFlexDecision] = useInputDataState('flexDecision')
    const [presentedClosingOffer, setPresentedClosingOffer] = useInputDataState('presentedClosingOffer')

    if (!flexOffer || isBusiness(script)) {
        return <></>
    }

    const hook = (e) => {
        setFlexDecision(e)
        setPresentedClosingOffer({target: {value: 'Y'}})
    }

    let presentedABFlexOffer = null
    if (plan && plan.toLowerCase() === 'select') {
        presentedABFlexOffer = <>
            <Row>
                <Form.Group>
                    <Form.Label>{labels.presentedClosingOffer}</Form.Label>
                    <FormCheck type="radio" label="Yes" value="Y" onChange={setPresentedClosingOffer}
                               checked={presentedClosingOffer === 'Y'}/>
                    <FormCheck type="radio" label="No" value="N" onChange={setPresentedClosingOffer}
                               checked={presentedClosingOffer === 'N'}/>
                </Form.Group>
            </Row>
        </>
    }

    return <>
        <Row className="mb-3 mt-3">
            <Col>
                <div dangerouslySetInnerHTML={{__html: flexOffer}}></div>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <FormCheck label="Accepted" value="accepted" checked={flexDecision === 'accepted'}
                               onChange={hook}/>
                    <FormCheck label="Rejected" value="rejected" checked={flexDecision === 'rejected'}
                               onChange={hook}/>
                </Form.Group>
            </Col>
        </Row>
        {presentedABFlexOffer}
    </>
}
